import { ENTITY_AVAILABILITY_STATUS } from "../enums/EntityAvailabilityStatus";

export const ENTITY_AVAILABILITY_STATUS_NAME = {
  [ENTITY_AVAILABILITY_STATUS.ACTIVE]: "Activo",
  [ENTITY_AVAILABILITY_STATUS.INACTIVE]: "Inactivo",
  [ENTITY_AVAILABILITY_STATUS.ARCHIVED]: "Archivado",
};

export const ENTITY_AVAILABILITY_STATUS_OPTIONS = [
  {
    id: ENTITY_AVAILABILITY_STATUS.ACTIVE,
    name: ENTITY_AVAILABILITY_STATUS_NAME[ENTITY_AVAILABILITY_STATUS.ACTIVE],
  },
  {
    id: ENTITY_AVAILABILITY_STATUS.INACTIVE,
    name: ENTITY_AVAILABILITY_STATUS_NAME[ENTITY_AVAILABILITY_STATUS.INACTIVE],
  },
  {
    id: ENTITY_AVAILABILITY_STATUS.ARCHIVED,
    name: ENTITY_AVAILABILITY_STATUS_NAME[ENTITY_AVAILABILITY_STATUS.ARCHIVED],
  },
];
